import { defineChannelContract } from 'shared/channels';
import type { EditableFieldValuesEntityName } from './fields';
import type { CreateFieldValueModel, EditFieldValueModel } from './fieldValueModel';

export interface FieldValuesMutation<TFieldValue> {
  fieldName: EditableFieldValuesEntityName;
  fieldValues: TFieldValue[];
}

/**
 * Field value mutations: the worker sends them to the API right away (not
 * through the HTTP queue) and answers once they are saved. The response has
 * no data on purpose: the saved values reach the page with the dictionary's
 * collection event after the follow-up sync (see `useFieldValues`).
 */
export const fieldValuesContract = defineChannelContract<{
  requests: {
    create: { request: FieldValuesMutation<CreateFieldValueModel>; response: void };
    edit: { request: FieldValuesMutation<EditFieldValueModel>; response: void };
  };
  // Saved values reach the page as each dictionary's collection event after the follow-up sync.
  events: Record<never, never>;
}>('fieldValuesChannel');
